var map = {
	"./0.png": 1648,
	"./0_dark.png": 7017,
	"./1.png": 8553,
	"./2.png": 370,
	"./3.png": 1499,
	"./4.png": 5588,
	"./5.png": 6717,
	"./6.png": 5478,
	"./7.png": 6876,
	"./8.png": 7016,
	"./9.png": 1633,
	"./home.png": 4379,
	"./map.png": 9725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8689;